import { render, staticRenderFns } from "./SafetyProgramApprove.vue?vue&type=template&id=b73bb55e"
import script from "./SafetyProgramApprove.vue?vue&type=script&lang=js"
export * from "./SafetyProgramApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports